export default {"src":"/_next/static/media/shopify.7c899f9e.svg","height":61,"width":215,"blurWidth":0,"blurHeight":0};